module.exports = __webpack_public_path__ + "static/media/chicargos-cart-page.3498d4b1.jpg";